import axios from 'axios'
import router from '../router'
import {Toast} from 'vant'

const service = axios.create({
  baseURL: process.env.BASE_API + process.env.CONTEXT_PATH,
  timeout: 50000,
  headers: {token: sessionStorage.getItem('token')}
})

// request 拦截器
service.interceptors.request.use(
  config => {
    config.headers['token'] = sessionStorage.getItem('token')
    // config.headers['token'] = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJndWxpLXVzZXIiLCJpYXQiOjE2NTI4NzQ0ODYsImV4cCI6MTY1Mjk2MDg4Niwib3BlbklkIjoib0d0Z3k2aTRlZTYzWWdOaG1hMG54TTllZXlpYyIsIm5pY2tuYW1lIjoiZm9yaSJ9.2f-pMerLvrtuaOz6diIKCO5lkpcuWrxqrynxc16uQNg'
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== '200') {
      Toast.fail(res.message)
      return Promise.reject(res.message)
    } else {
      return response.data
    }
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          router.replace(
            {
              path: '/login',
              query: {
                redirect_url: router.currentRoute.fullPath
              }
            }
          )
          break
        default:
          console.log('系统错误，code:' + error.response.status)
          Toast.fail('系统错误，code:' + error.response.status)
      }
    } else {
      console.log('网络异常，请刷新重试')
      Toast.fail('网络异常，请刷新重试')
    }
    console.log(error)
    return Promise.reject(error)
  }
)
export default service



// WEBPACK FOOTER //
// ./src/utils/request.js